import { Button, ButtonProps } from 'src/UIKit';
import React, { FC, useCallback } from 'react';
import { useMarkContactAsValidDialogController } from '../../controllers/MarkContactAsValidDialogController';
import { MarkContactAsValidDialogParams } from '../../types';


const useMarkContactAsValidDialog = () => {
  const { handleMarkContactAsValid, MarkContactAsValidDialog } =
    useMarkContactAsValidDialogController();

  const MarkContactAsValidButton: FC<MarkContactAsValidDialogParams & ButtonProps> = useCallback(
    props => (
      <Button
        fullWidth={props.fullWidth}
        variant="outlined"
        size="small"
        onClick={() => handleMarkContactAsValid(props)}
      >
        Mark as Valid
      </Button>
    ),
    [handleMarkContactAsValid],
  );

  return {
    handleMarkContactAsValid,
    MarkContactAsValidButton,
    MarkContactAsValidDialog,
  };
};

export default useMarkContactAsValidDialog;
